
import React, { useState, useEffect } from "react";
import Dropdown from "../components/CustomFields/Dropdown";
import InputField from "../components/CustomFields/InputField";
import GenderSelect from "./components/GenderSelect";
import { useSelector } from "react-redux";
import IndianDatePicker from "../../../Profile/ProfileSection/IndianDatePicker";
import { academyLogger } from "utils/logger";

const StudentDetails = ({ user, setUser, errors, setErrors }) => {
  const [customInput, setCustomInput] = useState("");
  const [showCustomInput, setShowCustomInput] = useState(false);

  const handleDynamicAttributeChange = (index, value) => {
    const newDynamicAttributes = [...user.dynamicAttributes];

    if (index === 0) {
      if (value === "Other") {
        setShowCustomInput(true);
        newDynamicAttributes[index].value = "Other"; // Store "Other" as the selected option
      } else {
        setShowCustomInput(false);
        setCustomInput("");
        newDynamicAttributes[index].value = value;
      }
    } else {
      newDynamicAttributes[index].value = value;
    }

    setUser({ ...user, dynamicAttributes: newDynamicAttributes });

    const fieldNames = ["howDidYouKnow", "registrationClass", "branch"];

    // Clear error when value is selected
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldNames[index]]: value ? "" : `${fieldNames[index]} is required`,
    }));
  };

  const handleCustomInputChange = (e) => {
    const value = e.target.value;
    setCustomInput(value);
    // Store the custom input value in a separate field
    setUser((prevUser) => ({
      ...prevUser,
      customHowDidYouKnow: value,
    }));
  };

  const company = useSelector((state) => state.companyReducer.company);
  // Log full branch objects
  useEffect(() => {
    if (company?.branches) {
      academyLogger.info("All Branch Details:", company.branches);
    }
  }, [company]);

  // don't remove branch, using this we setting the selected branch in company redux
  const branches = company?.branches?.map((branch) => branch.name) || [];

  const registrationClasses = [
    "LKG",
    "UKG",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII",
  ];

  const howDidYouKnowOptions = [
    "TV Ads",
    "Newspaper",
    "Social Media",
    "Friends",
    "Other",
  ];

  const handleDobChange = (e) => {
    const value = e.target.value;
    const year = value.split("-")[0];

    if (year.length === 4 && !isNaN(year)) {
      setUser({ ...user, dob: value });
      setErrors((prevErrors) => ({
        ...prevErrors,
        dob: "", // Clear error if valid
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        dob: "Invalid date, please enter a valid year",
      }));
    }
  };
  const companyStoredData = company;

  const branchField = companyStoredData?.hasBranch;


  return (
    <div>
      <h3 className="text-lg font-bold mb-4 text-center">Student Details</h3>

      {/* First Row: First Name & Branch (conditionally hidden) */}
      <div className={`grid gap-4 mb-4 ${branchField ? "grid-cols-1" : "grid-cols-2"}`}>
        <InputField
          id="firstName"
          label="Student Name *"
          value={user.firstName}
          // onChange={(e) => setUser({ ...user, firstName: e.target.value })}
          onChange={(e) => {
            setUser({ ...user, firstName: e.target.value });
            setErrors((prevErrors) => ({
              ...prevErrors,
              firstName: e.target.value ? "" : "Student Name is required",
            }));
          }}
          error={errors.firstName}
        />

        {branchField && (
          <Dropdown
            id="branch"
            label="Branch"
            value={user.dynamicAttributes[2].value}
            onChange={(e) => handleDynamicAttributeChange(2, e.target.value)}
            options={branches}
            defaultOption="Select Branch"
            error={errors.branch}
          />
        )}
      </div>

      {/* Second Row: Gender and Date of Birth */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="flex flex-col">
          <label
            htmlFor="gender"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Gender *
          </label>
          <GenderSelect
            id="gender"
            selectedGender={user.gender}
            onGenderChange={(value) => {
              setUser({ ...user, gender: value });
              setErrors((prevErrors) => ({
                ...prevErrors,
                gender: value ? "" : "Gender is required",
              }));
            }}
            error={errors.gender}
          />
        </div>

        <IndianDatePicker
          id="dob"
          label={"Date of Birth *"}
          name="dob"
          value={user.dob}
          onChange={handleDobChange}
        />
      </div>

      {/* Third Row: Registration Class and How Did You Know */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <Dropdown
          id="registrationClass"
          label="Registration Class *"
          value={user.dynamicAttributes[1].value}
          onChange={(e) => handleDynamicAttributeChange(1, e.target.value)}
          options={registrationClasses}
          defaultOption="Select Class"
          error={errors.registrationClass}
        />

        <div className="flex flex-col">
          <Dropdown
            id="howDidYouKnow"
            label="How did you know about Velammal?"
            value={user.dynamicAttributes[0].value}
            onChange={(e) => handleDynamicAttributeChange(0, e.target.value)}
            options={howDidYouKnowOptions}
            defaultOption="Select Option"
          // error={errors.howDidYouKnow}
          />
          {showCustomInput && (
            <div className="mt-2">
              <InputField
                id="customInput"
                label="Please specify"
                value={customInput}
                onChange={handleCustomInputChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;